import { FormField, IconButton, Loader, Tooltip } from '@wix/design-system';
import { Edit, Update } from '@wix/wix-ui-icons-common';
import { Place } from '../models/shared/Place';
import { useSettingsContext } from '../context/SettingsContext';

interface BusinessLocationProps {
    place: Place | null;
    onTrial: boolean;
    onEditLocation: () => void;
    onImportReviews: () => void;
}

export default function BusinessLocation({
    place,
    onTrial,
    onEditLocation,
    onImportReviews,
}: BusinessLocationProps) {
    const { settings, processing } = useSettingsContext();

    let LastUpdateInfoText = 'Reviews are automatically imported every 3 days';
    if (onTrial) {
        LastUpdateInfoText = 'Reviews are not automatically imported during the trial period';
    } else if (settings?.manual) {
        LastUpdateInfoText = 'Reviews are not automatically imported when the location is not connected through a public address';
    }

    let importTooltip = 'Import reviews for this location';
    if (settings?.manual) {
        importTooltip += '. This can take up to 24 hours but usually happens within few minutes';
    }

    let wasUpdatedToday = false;
    if (place?.updatedAt) {
        const today = new Date();
        wasUpdatedToday = place.updatedAt.toDateString() === today.toDateString();
    }

    return (
        <div className='section'>
            <FormField suffix={processing && <Loader size='tiny' />} label="Business">
                <div className='d-flex justify-content-between'>
                    <div className='d-flex align-items-center'>
                        <p>{settings?.placeName}</p>
                        {settings?.manual && <p className='ms-1 text-muted text-primary'>(Manual)</p>}
                        <Tooltip size='small' content='Change location'>
                            <IconButton onClick={onEditLocation} size='small' skin='standard' className='ms-2'>
                                <Edit />
                            </IconButton>
                        </Tooltip>
                        <Tooltip size='small' content={importTooltip}>
                            <IconButton size='small' skin="standard" priority="secondary" className='ms-2'
                                disabled={processing || wasUpdatedToday}
                                onClick={onImportReviews}
                            >
                                <Update />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
            </FormField>
            {place?.updatedAt && <div className='thin'>
                <FormField
                    label={`Last update: ${place.updatedAt.toLocaleString()}`}
                    labelSize='tiny'
                    infoContent={LastUpdateInfoText}
                />
            </div>}
        </div>
    );
}
